/**
 * Porté depuis apps/web/app/(shop)/retours/page.tsx (page statique, aucune
 * adaptation nécessaire au-delà de l'abandon de `generateMetadata`, hors
 * périmètre — cf. lot SEO/prérendu séparé).
 */
export function RetoursPage() {
  return (
    <div className="container-vvs py-8 lg:py-12">
      <h1 className="font-display text-2xl font-bold text-navy sm:text-3xl">Retours</h1>
      <div className="mt-4 max-w-prose space-y-6 font-body text-sm leading-relaxed text-muted">
        <div>
          <h2 className="font-display text-base font-semibold text-ink">Vérifiez votre article à la livraison</h2>
          <p className="mt-1">
            Comme la plupart des commandes sont réglées à la livraison, vous pouvez vérifier
            l&apos;article devant le livreur&nbsp;: référence, quantité et état général du produit.
            C&apos;est le moment le plus simple pour signaler un problème évident (article
            manquant, endommagé ou différent de la commande).
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Signaler un défaut après réception</h2>
          <p className="mt-1">
            Si un défaut n&apos;était pas visible au moment de la livraison, contactez-nous dans un
            délai raisonnable après réception, via WhatsApp, en précisant votre numéro de commande
            et la nature du problème. Chaque situation est examinée au cas par cas avec le
            vendeur concerné.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Conditions de retour</h2>
          <p className="mt-1">
            Pour être accepté, un article retourné doit généralement être non utilisé, dans son
            état et son emballage d&apos;origine, accompagné de ses éventuels accessoires. Certains
            produits (articles personnalisés, sous-vêtements, produits d&apos;hygiène ou de beauté
            descellés, par exemple) peuvent ne pas être éligibles au retour pour des raisons
            d&apos;hygiène ou de nature du produit.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Remboursement ou échange</h2>
          <p className="mt-1">
            Selon la disponibilité du produit et la nature du problème, un échange ou un
            remboursement vous est proposé, une fois l&apos;article retourné reçu et vérifié — aucun
            remboursement n&apos;est déclenché avant cette vérification.
          </p>
          <p className="mt-2">
            À titre indicatif, le traitement d&apos;une demande de retour prend généralement entre 5
            et 10 jours ouvrés après réception de l&apos;article. Le remboursement s&apos;effectue par
            le même moyen que le paiement initial : en espèces pour une commande réglée à la
            livraison (remise en main propre ou lors d&apos;un nouveau passage), ou par crédit mobile
            money pour un paiement effectué par ce moyen. Ces délais sont indicatifs et peuvent varier
            selon la situation ; les modalités exactes vous sont confirmées par notre équipe lors du
            traitement de votre demande.
          </p>
        </div>
      </div>
    </div>
  );
}
